const increment = 1000 / 60;

export default function Idler(durationMs) {
  let cachedValue;
  let idleMs = 0;

  const reset = () => {
    idleMs = 0;
  };
  
  const step = () => {
    idleMs += increment;
  };

  const isIdle = () => idleMs >= durationMs;

  return function idler(value) {
    if (value !== cachedValue) {
      reset();
      cachedValue = value;
      return false;
    }

    step();
    return isIdle();
  };
};